var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.48 24.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.9,3.59C18.51,1.2,15.37,0,12.24,0S5.98,1.2,3.59,3.59c-4.78,4.78-4.78,12.53,0,17.31,2.39,2.39,5.52,3.59,8.66,3.59s6.27-1.2,8.66-3.59c4.78-4.78,4.78-12.53,0-17.31Zm-15.9,1.41c1.93-1.93,4.51-3,7.24-3,2.4,0,4.67.82,6.5,2.33l-14.41,14.41c-3.31-4.02-3.08-9.99.67-13.74Zm14.48,14.48c-1.93,1.93-4.51,3-7.24,3-2.4,0-4.67-.82-6.5-2.33l14.41-14.41c3.31,4.02,3.08,9.99-.67,13.74Z",
    fill: "#624de3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.831346279743d941c96ca778a893a51c.svg";
export { ForwardRef as ReactComponent };